import { Box, CircularProgress, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

const LoaderContainer = styled(Box)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	minHeight: '100vh',
	gap: theme.spacing(2),
}))

interface PageLoaderProps {
	message?: string
}

export function PageLoader({ message }: PageLoaderProps) {
	return (
		<LoaderContainer role="status" aria-label={message ?? 'Loading'}>
			<CircularProgress size={48} aria-hidden="true" />
			{message && (
				<Typography variant="body2" color="text.secondary">
					{message}
				</Typography>
			)}
		</LoaderContainer>
	)
}
